import React from 'react';
import { bookingShape, historyShape, userShape } from 'constants/propTypes';
import { useManagedQuery } from 'utils/managedHooks';
import { withBooking } from 'components/queries/GetBookingQuery';
import { withUser } from 'components/queries/GetUserQuery';
import { GET_EXTRAS } from 'store/queries';
import { getAssistances, getValidExtras } from 'utils/booking';
import { getBooking } from './queries';
import { StyledStickyContainer } from '../BookingDetails.styles';
import BookingDetailsTable from '../BookingDetailsTable';
import ModuleTabs from '../ModuleTabs';
import Passengers from './Passengers';

import { getMinorsAmount, getFirstNonCancelledSegmentIsoDate } from 'utils/minors';

const Index = ({ booking, history, user = {} }) => {
  const { canEditPassengers } = user;

  const { data: dataExtras } = useManagedQuery(GET_EXTRAS, {
    variables: { reference: booking.reference }
  });

  const journeyExtras = dataExtras && [...dataExtras.booking.outboundExtras, ...dataExtras.booking.inboundExtras];
  const assistances = journeyExtras && getAssistances(journeyExtras);

  const filteredExtras = dataExtras && [
    ...getValidExtras(dataExtras.booking.outboundExtras),
    ...getValidExtras(dataExtras.booking.insurances),
    ...getValidExtras(dataExtras.booking.hotels),
    ...getValidExtras(dataExtras.booking.inboundExtras),
    ...getValidExtras(dataExtras.booking.travelPassProducts)
  ];

  const minorsAmount = getMinorsAmount(booking.additionalDetails);
  const minorOutbound = getFirstNonCancelledSegmentIsoDate(booking.outbound);
  const minorInbound = getFirstNonCancelledSegmentIsoDate(booking.inbound);
  const numberOfPassengers = booking.passengers?.length ?? 0;

  return (
    <>
      <StyledStickyContainer id="booking-details">
        <BookingDetailsTable booking={booking} />
        <ModuleTabs
          notes={booking.notes}
          reference={booking.reference}
          outbound={booking.nonExchangedOutbound}
          inbound={booking.nonExchangedInbound}
          booking={booking}
          assistances={assistances}
          extras={filteredExtras}
        />
      </StyledStickyContainer>
      <Passengers
        booking={booking}
        canEditPassengers={canEditPassengers}
        history={history}
        reference={booking.reference}
        isGroupBooking={booking.isGroupBooking}
        minorsAmount={minorsAmount}
        minorOutbound={minorOutbound}
        minorInbound={minorInbound}
        numberOfPassengers={numberOfPassengers}
        bookingStatus={booking.status}
        bookingReference={booking.reference}
        user={user}
      />
    </>
  );
};

Index.propTypes = {
  booking: bookingShape,
  history: historyShape,
  user: userShape
};

const options = {
  centerLoader: true
};
export default withBooking(withUser(Index), getBooking, options);
